import React, { memo, Profiler, useEffect, useState } from "react";
import { ItemTable, TableContainer, TableContent } from "./styles";

import IconInsatisfeito from '~/assets/icones/icon_insatisfeito.png';
import IconMuitoInsatisfeito from '~/assets/icones/icon_muito_insatisfeito.png';
import IconSatisfeito from '~/assets/icones/icon_satisfeito.png';
import IconMuitosatisfeito from '~/assets/icones/icon_muito_satisfeito.png';
import IconNormal from '~/assets/icones/icon_muito_normal.png';

function TableComponent({ comments = [], optionsFilter = {}, countFilterAvaliation, commentsRefs, setCountRefComment, countRefComment }) {
  const [dataFilter, setDataFilter] = useState([]);

  commentsRefs.current = [];
  
  useEffect(() => {
    let lista = [];

    if (countFilterAvaliation?.abertoMuitoSatisfeito) {
      lista = [...lista, ...(optionsFilter?.listaMuitoSatisfeito)];
    }

    if (countFilterAvaliation?.abertoSatisfeito) {
      lista = [...lista, ...(optionsFilter?.listaSatisfeito)];
    }

    if (countFilterAvaliation?.abertoNormal) {
      lista = [...lista, ...(optionsFilter?.listaNormal)];
    }

    if (countFilterAvaliation?.abertoInsatisfeito) {
      lista = [...lista, ...(optionsFilter?.listaInsatisfeito)];
    }

    if (countFilterAvaliation?.abertoMuitoInsatisfeito) {
      lista = [...lista, ...(optionsFilter?.listaMuitoInsatisfeito)];
    }

    setDataFilter(lista);
  }, [countFilterAvaliation, optionsFilter]);

  // const onRenderCallback = () => {
  //   console.log("TESTE", countRefComment);
    
  //   if (countRefComment == 0) {
  //     setCountRefComment(dataFilter?.length);
  //   }
  // };
  
  return dataFilter.length > 0 ? (
    (
      <TableContainer>
        <TableContent>
          {dataFilter?.map((itemComment, indiceComment) => (
            <ItemTable
              ref={ref => {
                if (ref) {
                  const find = commentsRefs.current.find((item) => item == ref);
                  !find && commentsRefs.current.push(ref);
                }
              }}
            >
              <div 
                className="search"
                onClick={() => {
                  setDataFilter((state) => {
                    let lista = [...state];
                    
                    lista[indiceComment].aberto = !lista[indiceComment].aberto;

                    return lista;
                  });

                }}
              >
                {
                  itemComment?.percentualSatisfacao > 80
                    ? (
                      <div className="icon">
                        <img src={IconMuitosatisfeito} alt="Vazio" />
                      </div>
                    ) : itemComment?.percentualSatisfacao > 60 ? (
                      <div className="icon">
                        <img src={IconSatisfeito} alt="Vazio" />
                      </div>
                    ) : itemComment?.percentualSatisfacao > 40 ? (
                      <div className="icon">
                        <img src={IconNormal} alt="Vazio" />
                      </div>
                    ) : itemComment?.percentualSatisfacao > 20 ? (
                      <div className="icon">
                        <img src={IconInsatisfeito} alt="Vazio" />
                      </div>
                    ) : (
                      <div className="icon">
                        <img src={IconMuitoInsatisfeito} alt="Vazio" />
                      </div>
                    )
                }
              </div>
              <div className="message">
                <div 
                  className="header" 
                  onClick={() => {
                    setDataFilter((state) => {
                      let lista = [...state];
                      
                      lista[indiceComment].aberto = !lista[indiceComment].aberto;

                      return lista;
                    });
                  }}
                >
                  <div className="author">
                    <p className="identification">{itemComment?.identificacao}</p>
                  </div>
                  <div className="information">
                    <p className="assessment">{"Satisfação " + itemComment?.percentualSatisfacao + "%"}</p>
                    <p className="service">{itemComment?.tituloServico}</p>
                    <p className="device">{itemComment?.tituloDispositivo}</p>
                    <p className="dateCreated">{itemComment?.dataCadastro + ' - ' + itemComment?.horaCadastro}</p>
                  </div>
                </div>
                {itemComment?.aberto && (
                  <div className="list-message">
                    {itemComment?.comentarios?.map((itemTexto) => (
                      <div className="content">
                        <p className="titulo">{itemTexto?.pergunta?.titulo}</p>
                        <p className="texto">{itemTexto?.texto}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </ItemTable>
          ))}
        </TableContent>
        {setCountRefComment(dataFilter?.length)}
      </TableContainer>
    )
  ) : (
    <div></div>
  )
}


export const Table = memo(TableComponent)